// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3hxjr","rootCenter":"LoadMoreObserver_rootCenter__3ZQnt","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3PIK1"};